import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { ValuesBand } from './components/ValuesBand';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'sv';
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" lang="sv" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="nw2e2bl1k0tq">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="st2hsfuf4rho" />}
      <TopBar data-id="element-2" data-mp="35ovwnmbgyrj" />
      <main data-id="element-3" data-mp="356r32ll9c80">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="34napqbl6vw3" />
        <StatsBand data-id="element-5" data-mp="3ud1e95yxri91" />
        <BeforeAfter data-id="element-6" data-mp="3ubrfeek9e61c" />
        <MeetingSelector data-id="element-7" data-mp="3uc9j1w993mja" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="3uf5i5nwu4h9b" />
        <SolutionSection data-id="element-9" data-mp="d3mmhhrnf7nb" />
        <ValuesBand data-id="element-10" data-mp="d3wbp34vdary" />
        <YearPlanSection data-id="element-11" data-mp="d2bhxfqdpvv5" />
        <MeetingsList data-id="element-12" data-mp="851m9icecnyv" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="86w6svjrae2f" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="3gle88ef6yvd2" />
        <GuaranteeSection data-id="element-15" data-mp="3glwd1zfx6hwl" />
        <FaqSection data-id="element-16" data-mp="3gja2rs1n9oao" />
        <FinalCta data-id="element-17" data-mp="3bmjqlfsyncuj" />
      </main>
      <Footer data-id="element-18" data-mp="3bncodr9xys0j" />
      <StickyCta data-id="element-19" data-mp="3bnutzeihuil4" />
    </div>;
}